import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=e52f96b6&scoped=true"
import script from "./userManagement.vue?vue&type=script&lang=js"
export * from "./userManagement.vue?vue&type=script&lang=js"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=e52f96b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52f96b6",
  null
  
)

export default component.exports